"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapshotNotificationTypeMetaSchema = void 0;
exports.SnapshotNotificationTypeMetaSchema = {
    "$id": "https://www.redbull.com/schemas/types/snapshot-notifications.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "SnapshotNotificationTypeMeta",
    "description": "Meta schema for snapshot notification definition",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^rrn:snapshot-notifications:[a-zA-Z0-9-]+$"
        },
        "type": {
            "type": "string",
            "enum": [
                "rrn:types:snapshot-notifications"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "examples": {
                    "type": "array",
                    "items": {
                        "type": "object"
                    }
                },
                "displayName": {
                    "type": "string",
                    "pattern": "^[A-Za-z0-9]+$"
                },
                "description": {
                    "type": "string"
                },
                "schema": {
                    "type": "object",
                    "properties": {
                        "properties": {
                            "description": "Those are the properties of the schema",
                            "type": "object",
                            "properties": {
                                "additionalProperties": true
                            }
                        }
                    },
                    "required": [
                        "properties"
                    ]
                }
            },
            "required": [
                "displayName",
                "schema"
            ]
        }
    },
    "required": [
        "id",
        "type",
        "attributes"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic25hcHNob3Qtbm90aWZpY2F0aW9ucy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy90eXBlcy9zbmFwc2hvdC1ub3RpZmljYXRpb25zLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELEtBQUssRUFBRSwwRUFBMEU7SUFDakYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsOEJBQThCO0lBQ3ZDLGFBQWEsRUFBRSxrREFBa0Q7SUFDakUsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixJQUFJLEVBQUU7WUFDSixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsNENBQTRDO1NBQ3hEO1FBQ0QsTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLGtDQUFrQzthQUNuQztTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsc0JBQXNCLEVBQUUsS0FBSztZQUM3QixZQUFZLEVBQUU7Z0JBQ1osVUFBVSxFQUFFO29CQUNWLE1BQU0sRUFBRSxPQUFPO29CQUNmLE9BQU8sRUFBRTt3QkFDUCxNQUFNLEVBQUUsUUFBUTtxQkFDakI7aUJBQ0Y7Z0JBQ0QsYUFBYSxFQUFFO29CQUNiLE1BQU0sRUFBRSxRQUFRO29CQUNoQixTQUFTLEVBQUUsZ0JBQWdCO2lCQUM1QjtnQkFDRCxhQUFhLEVBQUU7b0JBQ2IsTUFBTSxFQUFFLFFBQVE7aUJBQ2pCO2dCQUNELFFBQVEsRUFBRTtvQkFDUixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsWUFBWSxFQUFFO3dCQUNaLFlBQVksRUFBRTs0QkFDWixhQUFhLEVBQUUsd0NBQXdDOzRCQUN2RCxNQUFNLEVBQUUsUUFBUTs0QkFDaEIsWUFBWSxFQUFFO2dDQUNaLHNCQUFzQixFQUFFLElBQUk7NkJBQzdCO3lCQUNGO3FCQUNGO29CQUNELFVBQVUsRUFBRTt3QkFDVixZQUFZO3FCQUNiO2lCQUNGO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsYUFBYTtnQkFDYixRQUFRO2FBQ1Q7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsSUFBSTtRQUNKLE1BQU07UUFDTixZQUFZO0tBQ2I7Q0FDRixDQUFBIn0=